import React from 'react'
import { Paper, IconButton, Typography, AppBar, Toolbar } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { Menu } from '@mui/icons-material'
import { grey } from '@mui/material/colors'
import ExternalLink from 'components/ExternalLink'
import RadioButtons from 'components/RadioButtons'
import TextField from 'components/TextField'
import useStyles from './styles'

export interface IReferenceFormPreviewProps {
  name: string
}

const relationOptions = [
  { label: 'Friends', value: 'friend' },
  { label: 'Work colleague', value: 'coworker' },
  { label: 'Classmate', value: 'classmate' },
  { label: 'I was a client', value: 'client' },
  { label: 'Other', value: 'other' },
]

const professionalOptions = [
  { label: '5 - Expert', value: '5' },
  { label: '4 - Very good', value: '4' },
  { label: '3 - Good', value: '3' },
  { label: '2 - Basic', value: '2' },
  { label: '1 - Poor', value: '1' },
]

const recommendOptions = [
  { label: 'Yes', value: '5' },
  { label: 'No', value: '1' },
]

function ReferenceFormPreview(props: IReferenceFormPreviewProps) {
  const { name } = props
  const { classes } = useStyles()
  const theme = useTheme()

  return (
    <Paper>
      <AppBar position="static" style={{ backgroundColor: grey['800'] }}>
        <Toolbar>
          <IconButton size="large">
            <Menu style={{ color: '#FFF' }} />
          </IconButton>

          <Typography style={{ fontSize: '2rem', color: '#FFF' }}>
            Flexhire
          </Typography>
        </Toolbar>
      </AppBar>

      <Typography variant="h3" className={classes.title}>
        Reference for {name}
      </Typography>

      <br />

      <div className={classes.fields}>
        <TextField name="reference_name" disabled label="Enter your full name" style={{ width: '35%' }} />

        <Typography variant="body1" className={classes.statement}>How do you know {name}?</Typography>
        <RadioButtons disabled options={relationOptions} />

        <Typography variant="body1" className={classes.statement}>How well would you rate their professional talents?</Typography>
        <RadioButtons disabled options={professionalOptions} />

        <Typography variant="body1" className={classes.statement}>Would you recommend {name}?</Typography>
        <RadioButtons disabled options={recommendOptions} />

        <TextField
          name="comments"
          disabled
          label="Please leave any additional comments. Thank you"
          style={{ width: '70%' }}
        />
      </div>

      <div style={{ padding: theme.spacing(4) }}>
        Your feedback will be displayed on {name}'s profile on <ExternalLink href="https://flexhire.com" />
      </div>
    </Paper>
  )
}

export default React.memo(ReferenceFormPreview)
